import Vue from 'vue'
import Vuex from 'vuex'
import loginRoot from './loginRoot'
import { i18nManager } from '@/utils/i18n'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isShowLoading: false, // 全局 loading
        subjectColor:'#FFFFFF', //主题颜色
        tagColor:'#51CBCD',
        goodsInfo:{},
        uploadingUrl:'https://api.domo.hk/file/uploadObjectOSS', //上传域名
        ossUrl:'https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/', //静态资源域名
        routerArr:[],
        empId:'',//部门id
        currentLanguage: localStorage.getItem('language') || 'zh-TW' // 当前语言
    },
    mutations: {
        SET_GOODSINFO(state, data) {
            state.goodsInfo = data;
        },
        setRouterArr(state,data){
            state.routerArr = data
        },
        setEmpId(state,data){
            state.empId = data
        },
        SET_LANGUAGE(state, language) {
            state.currentLanguage = language;
            localStorage.setItem('language', language);
            i18nManager.setLanguage(language);
        }
    },
    modules:{
        loginRoot
    }
})

export default store